import EditIcon from "@mui/icons-material/Edit";
import { Alert, Grid } from "@mui/material";
import { useEffect, useState } from "react";

const GlobalAudienceEditActionStatus = ({
  editingAlert,
  setShowEditingAlert,
}) => {
  const [fadingEditAlert, setFadingEditAlert] = useState(false);

  useEffect(() => {
    if (editingAlert !== "edit") {
      const timer = setTimeout(() => {
        setFadingEditAlert(true);
        setTimeout(() => {
          setShowEditingAlert(false);
          setFadingEditAlert(false);
        }, 500);
      }, 2500);
      return () => clearTimeout(timer);
    }
  }, [editingAlert, setShowEditingAlert]);

  return (
    <Grid container>
      &nbsp;
      <Grid
        item
        xs={12}
        style={{ display: "flex", justifyContent: "flex-end" }}
      >
        {editingAlert === "edit" && (
          <Alert
            variant="filled"
            severity="info"
            icon={<EditIcon fontSize="inherit" />}
          >
            EDIT MODE
          </Alert>
        )}
        {editingAlert === "cancel" && (
          <Alert
            variant="filled"
            severity="error"
            sx={{ borderRadius: "4px", background: "#616161" }}
            style={{
              opacity: fadingEditAlert ? 0 : 1,
              transition: "opacity 0.5s ease",
            }}
          >
            CANCELED
          </Alert>
        )}
        {editingAlert === "updated" && (
          <Alert
            variant="filled"
            severity="success"
            style={{
              opacity: fadingEditAlert ? 0 : 1,
              transition: "opacity 0.5s ease",
            }}
          >
            UPDATED
          </Alert>
        )}
      </Grid>
    </Grid>
  );
};

export default GlobalAudienceEditActionStatus;
